import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { FiltersProvider } from '@data/providers';
import { SegmentedVariablesRepository } from '@data/repositories';
import type { TRecalculateItem } from '@data/types';

export const recalculateFilterResolver: ResolveFn<
  Promise<TRecalculateItem[]>
> = async () => {
  const segmentedVariablesRepository = inject(SegmentedVariablesRepository);
  const filtersProvider = inject(FiltersProvider);

  const result = await segmentedVariablesRepository.listRecalculateItems();

  const listItems = result.isOk === true ? result.data : [];

  filtersProvider.setRecalculate(listItems);

  return listItems;
};
